export const createAuthProvider = ({ logout }) => {
  return {
    login: () => {
      return Promise.resolve();
    },
    logout: () => {
      logout({ returnTo: window.location.origin });
    },
    checkAuth: () => {
      return Promise.resolve();
    },
    getPermissions: () => {
      return Promise.resolve();
    },
    checkError: () => {
      return Promise.resolve();
    },
  };
};